// Generated from posts.json for protected legacy scripts. Do not edit by hand.
export const blogPosts = [
  {
    "id": "mortgage-third-party-coordination",
    "slug": "mortgage-third-party-coordination",
    "title": "Mortgage Third-Party Coordination: How Brokers Keep Appraisers, Title and Insurance on Track",
    "description": "How brokers coordinate appraisers, title, escrow, insurance and verifiers in one mortgage file, with fewer emails and fewer missed documents.",
    "order": 30,
    "image": "/blog/images/mortgage-loan-file-banner.webp",
    "imageAlt": "Illustration of a mortgage file moving through connected workflow stages",
    "imageWidth": 1200,
    "imageHeight": 630,
    "contentPath": "/content/mortgage-third-party-coordination.html",
    "category": "Mortgage Industry",
    "featured": false,
    "layout": "default",
    "seoTitle": "Mortgage Third-Party Coordination for Brokers | CliQloan",
    "ogTitle": "Mortgage Third-Party Coordination: How Brokers Keep Appraisers, Title and Insurance on Track",
    "seoDescription": "How brokers coordinate appraisers, title, escrow, insurance and verifiers in one mortgage file, with fewer emails and fewer missed documents.",
    "canonicalPath": "/blog/mortgage-third-party-coordination/",
    "authorId": "raman-yakkala",
    "faqFormat": "paragraphs"
  },
  {
    "id": "what-to-include-on-a-loan-officer-website",
    "slug": "what-to-include-on-a-loan-officer-website",
    "title": "What to Include on a Loan Officer Website: A Practical Checklist",
    "description": "A practical checklist for loan officer websites: what to include, what borrowers look for and how to turn visits into applications.",
    "order": 29,
    "image": "/blog/images/mortgage-loan-file-banner.webp",
    "imageAlt": "Illustration of a mortgage file moving through connected workflow stages",
    "imageWidth": 1200,
    "imageHeight": 630,
    "contentPath": "/content/what-to-include-on-a-loan-officer-website.html",
    "category": "Mortgage Industry",
    "featured": false,
    "layout": "default",
    "seoTitle": "What to Include on a Loan Officer Website | CliQloan",
    "ogTitle": "What to Include on a Loan Officer Website: A Practical Checklist",
    "seoDescription": "A practical checklist for loan officer websites: what to include, what borrowers look for and how to turn visits into applications.",
    "canonicalPath": "/blog/what-to-include-on-a-loan-officer-website/",
    "authorId": "raman-yakkala",
    "faqFormat": "paragraphs"
  },
  {
    "id": "how-to-choose-a-loan-origination-system",
    "slug": "how-to-choose-a-loan-origination-system",
    "title": "How to Choose a Loan Origination System for a Small Mortgage Brokerage",
    "description": "A practical checklist for choosing a loan origination system for a small mortgage brokerage: features, demo questions and red flags.",
    "order": 28,
    "image": "/blog/images/mortgage-loan-file-banner.webp",
    "imageAlt": "Illustration of a mortgage file moving through connected workflow stages",
    "imageWidth": 1200,
    "imageHeight": 630,
    "contentPath": "/content/how-to-choose-a-loan-origination-system.html",
    "category": "Mortgage Industry",
    "featured": false,
    "layout": "default",
    "seoTitle": "How to Choose a Loan Origination System | CliQloan",
    "ogTitle": "How to Choose a Loan Origination System for a Small Mortgage Brokerage",
    "seoDescription": "A practical checklist for choosing a loan origination system for a small mortgage brokerage: features, demo questions and red flags.",
    "canonicalPath": "/blog/how-to-choose-a-loan-origination-system/",
    "authorId": "raman-yakkala",
    "faqFormat": "paragraphs"
  },
  {
    "id": "mortgage-loan-file-checklist",
    "slug": "mortgage-loan-file-checklist",
    "title": "The Mortgage Loan File Checklist: What Brokers Collect at Each Stage",
    "description": "A stage-by-stage mortgage loan file checklist for brokers and processors: what to collect, why it matters and where files stall.",
    "order": 27,
    "image": "/blog/images/mortgage-loan-file-banner.webp",
    "imageAlt": "Illustration of a mortgage file moving through connected workflow stages",
    "imageWidth": 1200,
    "imageHeight": 630,
    "contentPath": "/content/mortgage-loan-file-checklist.html",
    "category": "Mortgage Industry",
    "featured": false,
    "layout": "default",
    "seoTitle": "Mortgage Loan File Checklist for Brokers | CliQloan",
    "ogTitle": "The Mortgage Loan File Checklist: What Brokers Collect at Each Stage",
    "seoDescription": "A stage-by-stage mortgage loan file checklist for brokers and processors: what to collect, why it matters and where files stall.",
    "canonicalPath": "/blog/mortgage-loan-file-checklist/",
    "authorId": "raman-yakkala",
    "faqFormat": "paragraphs"
  },
  {
    "id": "loan-origination-system-workflow",
    "slug": "loan-origination-system-workflow",
    "title": "Loan Origination System Workflow: The 8 Stages From Lead to Funding",
    "description": "The eight stages a mortgage file moves through, who owns each one, and where brokers lose time.",
    "order": 26,
    "image": "/assets/loan-origination-system-workflow.png",
    "imageAlt": "Illustration of a mortgage file moving through connected workflow stages",
    "heroImageAlt": "Illustration of a mortgage file moving through connected workflow stages",
    "imageWidth": 1200,
    "imageHeight": 630,
    "preloadHero": true,
    "contentPath": "/content/loan-origination-system-workflow.html",
    "category": "Mortgage Industry",
    "featured": false,
    "layout": "default",
    "seoTitle": "Loan Origination System Workflow: 8 Stages | CliQloan",
    "ogTitle": "Loan Origination System Workflow: The 8 Stages From Lead to Funding",
    "seoDescription": "How a loan origination system workflow runs from lead to funding, who owns each stage, and where mortgage files stall. A practical guide for brokers.",
    "canonicalPath": "/blog/loan-origination-system-workflow",
    "authorId": "raman-yakkala"
  },
  {
    "id": "mortgage-broker-tools",
    "slug": "mortgage-broker-tools",
    "title": "Mortgage Broker Tools: The 9 Categories a Brokerage Needs",
    "description": "The nine tool categories a brokerage runs on, what to look for in each, and how to avoid paying twice for the same data.",
    "order": 25,
    "image": "/assets/mortgage-broker-tools.png",
    "imageAlt": "Illustration of connected software tools on a mortgage broker's desk",
    "heroImageAlt": "Illustration of connected software tools on a mortgage broker's desk",
    "imageWidth": 1200,
    "imageHeight": 630,
    "preloadHero": true,
    "contentPath": "/content/mortgage-broker-tools.html",
    "category": "Mortgage Industry",
    "featured": false,
    "layout": "default",
    "seoTitle": "Mortgage Broker Tools: The 9 Categories a Brokerage Needs | CliQloan",
    "ogTitle": "Mortgage Broker Tools: The 9 Categories a Brokerage Needs",
    "seoDescription": "The nine types of mortgage broker tools, what each one does, how to choose them, and how to keep data moving between them without retyping.",
    "canonicalPath": "/blog/mortgage-broker-tools",
    "authorId": "raman-yakkala"
  },
  {
    "id": "your-borrowers-dont-hate-mortgages-they-hate-the-process",
    "slug": "your-borrowers-dont-hate-mortgages-they-hate-the-process",
    "title": "Borrower Experience: What Actually Frustrates Them",
    "description": "Borrowers do not object to the mortgage. They object to the process. What causes the frustration and how lenders remove it.",
    "order": 24,
    "image": "/assets/your-borrowers-dont-hate-mortgages-they-hate-the-process.png",
    "imageAlt": "Illustration for Your Borrowers Don't Hate Mortgages. They Hate the Process",
    "imageWidth": 1280,
    "imageHeight": 720,
    "contentPath": "/content/your-borrowers-dont-hate-mortgages-they-hate-the-process.html",
    "category": "Loan Experience",
    "featured": false,
    "layout": "default",
    "seoTitle": "Borrower Experience: What Actually Frustrates Them",
    "seoDescription": "Borrowers do not object to the mortgage. They object to the process. What causes the frustration and how lenders remove it.",
    "canonicalPath": "/blog/your-borrowers-dont-hate-mortgages-they-hate-the-process",
    "authorId": "raman-yakkala"
  },
  {
    "id": "a-clearer-mortgage-workflow-starts-with-the-documents",
    "slug": "a-clearer-mortgage-workflow-starts-with-the-documents",
    "title": "Mortgage Document Collection: How to Stop Asking Twice",
    "description": "Why mortgage files stall on documents you already have, what repeated requests cost, and how structured intake fixes it.",
    "order": 20,
    "image": "/assets/a-clearer-mortgage-workflow-starts-with-the-documents.png",
    "imageAlt": "Illustration for A Clearer Mortgage Workflow Starts With the Documents",
    "imageWidth": 1280,
    "imageHeight": 720,
    "contentPath": "/content/a-clearer-mortgage-workflow-starts-with-the-documents.html",
    "category": "Loan Experience",
    "featured": false,
    "layout": "default",
    "seoTitle": "Mortgage Document Collection: How to Stop Asking Twice",
    "seoDescription": "Why mortgage files stall on documents you already have, what repeated requests cost, and how structured intake fixes it.",
    "canonicalPath": "/blog/a-clearer-mortgage-workflow-starts-with-the-documents",
    "authorId": "raman-yakkala"
  },
  {
    "id": "how-brokers-mlos-and-processors-can-stay-in-the-same-loan-file",
    "slug": "how-brokers-mlos-and-processors-can-stay-in-the-same-loan-file",
    "title": "Mortgage Team Collaboration: One Shared Loan File",
    "description": "How brokers, MLOs and processors lose time to disconnected systems, and what a single shared loan file changes.",
    "order": 19,
    "image": "/assets/how-brokers-mlos-and-processors-can-stay-in-the-same-loan-file.png",
    "imageAlt": "Illustration for How Brokers, MLOs, and Processors Can Stay in the Same Loan File",
    "imageWidth": 1480,
    "imageHeight": 829,
    "contentPath": "/content/how-brokers-mlos-and-processors-can-stay-in-the-same-loan-file.html",
    "category": "Loan Experience",
    "featured": false,
    "layout": "default",
    "seoTitle": "Mortgage Team Collaboration: One Shared Loan File",
    "seoDescription": "How brokers, MLOs and processors lose time to disconnected systems, and what a single shared loan file changes.",
    "canonicalPath": "/blog/how-brokers-mlos-and-processors-can-stay-in-the-same-loan-file",
    "authorId": "raman-yakkala"
  },
  {
    "id": "why-legacy-loan-origination-systems-are-holding-lenders-back",
    "slug": "why-legacy-loan-origination-systems-are-holding-lenders-back",
    "title": "Legacy Loan Origination Systems: Why They Hold Lenders Back",
    "description": "What older LOS platforms cost lenders in speed, compliance and staff time, and what a modern loan origination workflow looks like.",
    "order": 18,
    "image": "/assets/why-legacy-loan-origination-systems-are-holding-lenders-back.png",
    "imageAlt": "Illustration for Why Legacy Loan Origination Systems Are Holding Lenders Back",
    "imageWidth": 1480,
    "imageHeight": 829,
    "contentPath": "/content/why-legacy-loan-origination-systems-are-holding-lenders-back.html",
    "category": "Loan Experience",
    "featured": false,
    "layout": "default",
    "seoTitle": "Legacy Loan Origination Systems: Why They Hold Lenders Back",
    "seoDescription": "What older LOS platforms cost lenders in speed, compliance and staff time, and what a modern loan origination workflow looks like.",
    "canonicalPath": "/blog/why-legacy-loan-origination-systems-are-holding-lenders-back",
    "authorId": "raman-yakkala"
  },
  {
    "id": "why-ai-is-the-future-of-loan-processing",
    "slug": "why-ai-is-the-future-of-loan-processing",
    "title": "AI in Loan Processing: Where It Reduces Errors and Delays",
    "description": "Where AI genuinely helps in mortgage processing, where it does not, and why structured document intake has to come first.",
    "order": 14,
    "image": "/assets/why-ai-is-the-future-of-loan-processing-v2.png",
    "imageAlt": "Illustration for Why AI Is the Future of Loan Processing",
    "heroImageAlt": "Illustration of mortgage documents moving into one shared loan file",
    "imageWidth": 1480,
    "imageHeight": 991,
    "contentPath": "/content/why-ai-is-the-future-of-loan-processing.html",
    "category": "Loan Experience",
    "featured": false,
    "layout": "default",
    "seoTitle": "AI in Loan Processing: Where It Reduces Errors and Delays",
    "seoDescription": "Where AI genuinely helps in mortgage processing, where it does not, and why structured document intake has to come first.",
    "canonicalPath": "/blog/why-ai-is-the-future-of-loan-processing",
    "authorId": "raman-yakkala"
  },
  {
    "id": "from-application-to-approval-automating-the-entire-loan-journey",
    "slug": "from-application-to-approval-automating-the-entire-loan-journey",
    "title": "Mortgage Workflow Automation: From Application to Approval",
    "description": "What mortgage workflow automation covers end to end, which steps benefit most, and what to automate first.",
    "order": 11,
    "image": "/assets/from-application-to-approval-automating-the-entire-loan-journey-v2.png",
    "imageAlt": "Illustration for From Application to Approval: Automating the Entire Loan Journey",
    "heroImageAlt": "Illustration of a loan file moving from application to lender submission",
    "imageWidth": 752,
    "imageHeight": 423,
    "contentPath": "/content/from-application-to-approval-automating-the-entire-loan-journey.html",
    "category": "Loan Experience",
    "featured": false,
    "layout": "default",
    "seoTitle": "Mortgage Workflow Automation: From Application to Approval",
    "seoDescription": "What mortgage workflow automation covers end to end, which steps benefit most, and what to automate first.",
    "canonicalPath": "/blog/from-application-to-approval-automating-the-entire-loan-journey",
    "authorId": "raman-yakkala"
  },
  {
    "id": "why-loan-pipelines-look-healthy-but-closings-still-get-delayed",
    "slug": "why-loan-pipelines-look-healthy-but-closings-still-get-delayed",
    "title": "Why Mortgage Closings Get Delayed Despite a Healthy Pipeline",
    "description": "Pipeline reports show movement while closings slip. Where the time actually goes between application and consummation.",
    "order": 10,
    "image": "/assets/why-loan-pipelines-look-healthy-but-closings-still-get-delayed.png",
    "imageAlt": "Illustration for Why Loan Pipelines Look Healthy but Closings Still Get Delayed",
    "imageWidth": 1280,
    "imageHeight": 720,
    "contentPath": "/content/why-loan-pipelines-look-healthy-but-closings-still-get-delayed.html",
    "category": "Loan Experience",
    "featured": false,
    "layout": "default",
    "seoTitle": "Why Mortgage Closings Get Delayed Despite a Healthy Pipeline",
    "seoDescription": "Pipeline reports show movement while closings slip. Where the time actually goes between application and consummation.",
    "canonicalPath": "/blog/why-loan-pipelines-look-healthy-but-closings-still-get-delayed",
    "authorId": "raman-yakkala"
  },
  {
    "id": "what-actually-happens-between-approved-and-closed-in-lending",
    "slug": "what-actually-happens-between-approved-and-closed-in-lending",
    "title": "Between Approved and Closed: What Happens in a Mortgage File",
    "description": "Approval is not the finish line. What runs between conditional approval and consummation, and where files stall.",
    "order": 8,
    "image": "/assets/what-actually-happens-between-approved-and-closed-in-lending.png",
    "imageAlt": "Illustration for What Actually Happens Between “Approved” and “Closed” in Lending",
    "imageWidth": 1280,
    "imageHeight": 720,
    "contentPath": "/content/what-actually-happens-between-approved-and-closed-in-lending.html",
    "category": "Loan Experience",
    "featured": false,
    "layout": "default",
    "seoTitle": "Between Approved and Closed: What Happens in a Mortgage File",
    "seoDescription": "Approval is not the finish line. What runs between conditional approval and consummation, and where files stall.",
    "canonicalPath": "/blog/what-actually-happens-between-approved-and-closed-in-lending",
    "authorId": "raman-yakkala"
  },
  {
    "id": "how-digital-platforms-revolutionize-the-mortgage-industry",
    "slug": "how-digital-platforms-revolutionize-the-mortgage-industry",
    "title": "Digital Mortgage Platforms: How They Changed Origination",
    "description": "What a digital mortgage platform actually replaces, what changed in origination over the last decade, and what has not.",
    "order": 6,
    "image": "/assets/how-digital-platforms-revolutionize-the-mortgage-industry.png",
    "imageAlt": "Digital platforms transforming the mortgage industry",
    "imageWidth": 1480,
    "imageHeight": 830,
    "contentPath": "/content/how-digital-platforms-revolutionize-the-mortgage-industry.html",
    "category": "Mortgage Industry",
    "featured": false,
    "layout": "default",
    "seoTitle": "Digital Mortgage Platforms: How They Changed Origination",
    "seoDescription": "What a digital mortgage platform actually replaces, what changed in origination over the last decade, and what has not.",
    "canonicalPath": "/blog/how-digital-platforms-revolutionize-the-mortgage-industry",
    "legacyId": 1,
    "authorId": "raman-yakkala"
  },
  {
    "id": "challenges-in-todays-world-for-mortgage-loan-officers",
    "slug": "challenges-in-todays-world-for-mortgage-loan-officers",
    "title": "Mortgage Loan Officer Challenges in 2026",
    "description": "The operational pressures loan officers face today, from document chasing to compliance load, and what removes them.",
    "order": 5,
    "image": "/assets/challenges-in-todays-world-for-mortgage-loan-officers.png",
    "imageAlt": "Mortgage loan officer facing modern industry challenges",
    "imageWidth": 1480,
    "imageHeight": 829,
    "contentPath": "/content/challenges-in-todays-world-for-mortgage-loan-officers.html",
    "category": "Mortgage Industry",
    "featured": false,
    "layout": "default",
    "seoTitle": "Mortgage Loan Officer Challenges in 2026",
    "seoDescription": "The operational pressures loan officers face today, from document chasing to compliance load, and what removes them.",
    "canonicalPath": "/blog/challenges-in-todays-world-for-mortgage-loan-officers",
    "legacyId": 2,
    "authorId": "raman-yakkala"
  },
  {
    "id": "the-importance-of-effective-communication-in-mortgage-origination",
    "slug": "the-importance-of-effective-communication-in-mortgage-origination",
    "title": "Borrower Communication for Loan Officers",
    "description": "Why borrower trust is built through visibility rather than reassurance, and what to communicate at each stage.",
    "order": 2,
    "image": "/assets/the-importance-of-effective-communication-in-mortgage-origination.png",
    "imageAlt": "Effective communication during mortgage origination",
    "imageWidth": 1480,
    "imageHeight": 830,
    "contentPath": "/content/the-importance-of-effective-communication-in-mortgage-origination.html",
    "category": "Mortgage Industry",
    "featured": false,
    "layout": "default",
    "seoTitle": "Borrower Communication for Loan Officers",
    "seoDescription": "Why borrower trust is built through visibility rather than reassurance, and what to communicate at each stage.",
    "canonicalPath": "/blog/the-importance-of-effective-communication-in-mortgage-origination",
    "legacyId": 5,
    "authorId": "raman-yakkala"
  }
];

export const getSortedBlogPosts = () =>
  [...blogPosts].sort((a, b) => (b.order || 0) - (a.order || 0));

export const getBlogPostBySlug = (slug) =>
  blogPosts.find((post) => post.slug === slug);

export const getBlogPostByLegacyId = (id) =>
  blogPosts.find((post) => post.legacyId === Number(id));
